export default "__VITE_ASSET__CMcXBgWU__"